import React, { useEffect, useState } from "react";
import { fetchUserInsights } from "../services/influancerService";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Navbar from "../../components/Navbar";

const Insights = () => {
  const navigate = useNavigate();
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getInsights = async () => {
      try {
        const response = await fetchUserInsights();
        setInsights(response.data.insights); // Assuming insights data is in `data.insights`
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch insights");
        setLoading(false);
      }
    };
    getInsights();
  }, []);

  if (loading) {
    return (
      <>
    <Navbar/>
      <div className="flex flex-col items-center justify-center min-h-screen bg-orange-500">
        {/* Loading Spinner */}
        <div className="animate-spin mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.354a8.001 8.001 0 11-4.244 14.907M4.354 12a8.001 8.001 0 0114.907-4.244"
            />
          </svg>
        </div>
        <div className="text-center text-white">
          <h1 className="text-xl font-semibold">Fetching your Insights</h1>
          <p className="text-sm mt-2">This shouldn't take long</p>
        </div>
      </div>
      </>
    );
  }

  if (error)
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl font-semibold text-red-500">{error}</div>
      </div>
    );

  const handleBackClick = () => {
    navigate("/influencer/dashboard");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Fixed Navbar */}
      <div className="fixed top-0 w-full bg-white shadow z-50">
        <Navbar />
      </div>

      {/* Page Content */}
      <div className="pt-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow rounded-lg p-6 relative">
            {/* Back button (Only visible on mobile) */}
            <button
              onClick={handleBackClick}
              className="absolute top-7 left-2  flex items-center text-gray-700"
            >
              <FaArrowLeft className="h-5 w-5 mr-2" />
              {/* <span>Back</span> */}
            </button>

            {/* Header */}
            <h2 className="text-2xl lg:text-center lg:mt-4 font-bold text-gray-800 mb-4 text-center lg:text-left">
              Instagram Insights
            </h2>
            <p className="text-gray-600 text-center lg:text-left mb-6">
              Here's a summary of your Instagram account's performance. Keep track of your reach, engagement, and post performance data.
            </p>

            {/* Insights Grid */}
            {insights ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <InsightCard title="Reach" value={insights?.reach || 0} bg="bg-blue-100" text="text-blue-900" />
                <InsightCard title="Profile Views" value={insights?.views || 0} bg="bg-green-100" text="text-green-900" />
                <InsightCard title="Accounts Engaged" value={insights?.accountsEngaged || 0} bg="bg-yellow-100" text="text-yellow-900" />
                <InsightCard title="Likes" value={insights?.likes || 0} bg="bg-purple-100" text="text-purple-900" />
                <InsightCard title="Comments" value={insights?.comments || 0} bg="bg-pink-100" text="text-pink-900" />
              </div>
            ) : (
              <p className="text-gray-600 text-center">No insights available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable Insight Card Component
const InsightCard = ({ title, value, bg, text }) => (
  <div className={`${bg} p-4 rounded-lg shadow text-center`}>
    <h3 className={`text-lg font-semibold ${text}`}>{title}</h3>
    <p className={`text-xl font-bold ${text}`}>{value}</p>
  </div>
);

export default Insights;
